<div
  [ngClass]="themeClassObject"
  [ngStyle]="ngStyle"
>
  {{ message }}
</div>
